import { UPDATE_PROFILE } from '@storeOld/actions'
import { call, put, select } from 'redux-saga/effects'

import { authSelector } from '@/hooks/useAuth'
import { NestClient } from '@/nest'
import type { AuthState } from '@/types'
import { getBrowserTimezone } from '@/utils/getBrowserTimezone'
import type { AccountUpdateResult } from '../types'

// After every auth load: if the browser's zone is not the one on the account,
// tell the server, quietly. No toast: the person changed nothing
export function* syncTimezone() {
  const auth: AuthState = yield select(authSelector)
  const timezone = getBrowserTimezone()

  if (!auth.authenticated || !timezone || auth.timezone === timezone) {
    return
  }

  try {
    const updated: AccountUpdateResult = yield call(NestClient.account.update, {
      timezone,
    })

    yield put({ type: UPDATE_PROFILE, payload: updated })
  } catch (error) {
    console.error('Error syncing the timezone:', error)
  }
}
